import React from "react";

const ShippingDeliveryPolicy = () => {
  return (
    <div className="bg-gray-50 dark:bg-gray-950 min-h-screen py-16 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-4xl mx-auto bg-white dark:bg-gray-900 shadow-xl rounded-2xl overflow-hidden border border-gray-100 dark:border-gray-700">
        {/* Premium Header */}
        <header className="bg-slate-900 dark:bg-slate-800 py-12 px-8 text-center text-white border-b dark:border-slate-700">
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight uppercase border-b-4 border-white inline-block pb-2 mb-4">
            Shipping & Delivery Policy
          </h1>
          <p className="text-lg font-semibold text-slate-300">
           Brightex Solutions Pvt Ltd
          </p>
          <p className="text-sm text-slate-400 mt-2 tracking-widest uppercase">
            Effective Date: February 2026
          </p>
        </header>

        {/* Content Body */}
        <div className="p-8 md:p-14 space-y-12 text-gray-700 dark:text-gray-300 leading-relaxed">
          {/* Section 1 */}
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4 border-l-4 border-slate-900 dark:border-slate-100 pl-4">
              1. OVERVIEW
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              Thank you for shopping at Lapzop. Below is our shipping policy to
              help you understand how and when your order will arrive. We
              utilize Shiprocket to ensure your refurbished laptops are
              delivered safely across India.
            </p>
          </section>

          {/* Section 2 */}
          <section className="bg-slate-50 dark:bg-gray-800 p-6 rounded-xl border border-slate-100 dark:border-gray-700">
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4">
              2. ORDER PROCESSING & QC
            </h3>
            <div className="space-y-4 text-gray-600 dark:text-gray-400">
              <p>
                <strong className="text-slate-900 dark:text-slate-200">Quality Check (QC):</strong>{" "}
                Dispatch will be done after 24 hours of your order to allow for
                a final, rigorous Quality Check of the laptops to ensure they
                meet our functional standards.
              </p>
              <p>
                <strong className="text-slate-900 dark:text-slate-200">Processing Time:</strong> All
                orders are processed within 1–3 business days, excluding Sundays
                and public holidays.
              </p>
              <p>
                <strong className="text-slate-900 dark:text-slate-200">Notifications:</strong> You
                will receive a confirmation email once your order is placed, and
                another when it ships.
              </p>
              <p className="italic text-sm">
                <strong className="text-slate-900 dark:text-slate-200">High-Volume Periods:</strong>{" "}
                During sales or holidays, processing may take slightly longer;
                we appreciate your patience.
              </p>
            </div>
          </section>

          {/* Section 3 */}
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4 border-l-4 border-slate-900 dark:border-slate-100 pl-4">
              3. SHIPPING METHODS & DELIVERY TIME
            </h3>
            <p className="mb-6">
              We offer comprehensive shipping across India. Estimated delivery
              times after dispatch are as follows:
            </p>
            <div className="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-slate-900 text-white">
                    <th className="p-4 font-bold uppercase text-sm tracking-wider">
                      Region
                    </th>
                    <th className="p-4 font-bold uppercase text-sm tracking-wider">
                      Estimated Delivery Time
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                  <tr className="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
                    <td className="p-4 font-semibold text-slate-900 dark:text-slate-200">
                      Tier 1 Cities
                    </td>
                    <td className="p-4 text-gray-600 dark:text-gray-400">
                      1–3 business days after dispatch.
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
                    <td className="p-4 font-semibold text-slate-900 dark:text-slate-200">
                      Tier 2 Cities
                    </td>
                    <td className="p-4 text-gray-600 dark:text-gray-400">
                      2–5 business days after dispatch.
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
                    <td className="p-4 font-semibold text-slate-900 dark:text-slate-200">
                      Tier 3 Cities (incl. North East)
                    </td>
                    <td className="p-4 text-gray-600 dark:text-gray-400">
                      3–6 business days after dispatch.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="mt-4 text-sm italic text-gray-500">
              Note: Delivery times may vary depending on your specific location
              and the carrier assigned by Shiprocket.
            </p>
          </section>

          {/* Section 4 */}
          <section className="bg-green-50 dark:bg-green-950/30 p-6 rounded-xl border border-green-100 dark:border-green-900">
            <h3 className="text-xl font-bold text-green-900 dark:text-green-400 mb-4">
              4. SHIPPING RATES
            </h3>
            <div className="space-y-3">
              <p className="flex items-center gap-2">
                <span className="text-green-600 dark:text-green-400 font-bold">✓</span>
                <span>
                  <strong className="text-green-900 dark:text-green-400">
                    Free Home Delivery:
                  </strong>{" "}
                  We are proud to provide Free Home Delivery across all
                  serviceable pin codes in India.
                </span>
              </p>
              <p className="flex items-center gap-2">
                <span className="text-green-600 dark:text-green-400 font-bold">✓</span>
                <span>
                  <strong className="text-green-900 dark:text-green-400">Standard Shipping:</strong>{" "}
                  Free standard shipping on all laptop orders with no hidden
                  costs at checkout.
                </span>
              </p>
            </div>
          </section>

          {/* Section 5 */}
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4 border-l-4 border-slate-900 dark:border-slate-100 pl-4">
              5. ORDER TRACKING
            </h3>
            <div className="space-y-4">
              <p>
                <strong className="text-slate-900 dark:text-slate-200">Real-Time Tracking:</strong>{" "}
                Once your order has shipped, you will receive an email
                containing a tracking number and a link to track your package.
              </p>
              <div className="p-4 bg-white dark:bg-gray-800 border border-dashed border-slate-300 dark:border-gray-600 rounded-lg inline-block">
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-2 font-medium">
                  Official Tracking Link:
                </p>
                <a
                  href="https://www.shiprocket.in/shipment-tracking/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 dark:text-blue-400 font-bold hover:underline break-all"
                >
                  https://www.shiprocket.in/shipment-tracking/
                </a>
              </div>
            </div>
          </section>

          {/* Section 6 */}
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4 border-l-4 border-slate-900 dark:border-slate-100 pl-4">
              6. DELAYS & EXCEPTIONS
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              While we strive for on-time delivery, shipping delays may
              occasionally occur due to:
            </p>
            <ul className="list-disc ml-6 space-y-2 text-gray-600 dark:text-gray-400">
              <li>Extreme weather conditions.</li>
              <li>Carrier-specific logistical delays.</li>
              <li>High-volume periods or national holidays.</li>
            </ul>
          </section>

          {/* Section 7 - Contact & Legal */}
          <footer className="mt-12 p-8 bg-slate-100 dark:bg-gray-800 rounded-2xl border border-slate-200 dark:border-gray-700">
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4 uppercase tracking-tight">
              7. Contact & Legal Information
            </h3>
            <div className="space-y-4 text-slate-700 dark:text-slate-300">
              <p className="font-bold">Brightex Solutions Pvt Ltd</p>
              <p className="text-sm leading-relaxed max-w-md">
                <span className="font-semibold">
                  Principal Place of Business:
                </span>{" "}
                No. 5 and 6, Krishnappa Compound, Jaraganahally, JP Nagar 7th
                Phase, Kanakapura Main Road, Bengaluru, Karnataka, 560078
              </p>
              <p className="text-sm">
                <span className="font-semibold tracking-wide">GSTIN:</span>{" "}
                29AAICB6992P1ZL
              </p>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default ShippingDeliveryPolicy;
